import React, { CSSProperties } from "react";
import videojs, {
  VideoJsPlayer,
  VideoJsPlayerOptions,
} from "video.js/dist/video.es.js";
import "video.js/dist/video-js.css";

// Styles
import "video.js/dist/video-js.css";

import { QualitySelector } from "./quality-selector/index.js";
import { cn } from "../../../../lib/utils/index.js";

interface IVideoPlayerProps {
  options: VideoJsPlayerOptions;
}

const initialOptions: VideoJsPlayerOptions = {
  controls: true,
  fluid: true,
  controlBar: {
    volumePanel: {
      inline: false,
    },
  },
};

const VideoPlayer: React.FC<
  IVideoPlayerProps & { style?: CSSProperties; className?: string }
> = ({ options, style, className }) => {
  const videoNode = React.useRef<HTMLVideoElement>(null);
  const player = React.useRef<videojs.Player>(null);

  React.useEffect(() => {
    QualitySelector(videojs);

    player.current = videojs(videoNode.current, {
      ...initialOptions,
      ...options,
    }).ready(function () {
      if (
        !this.controlBar
          .children()
          .some((c: { name_: string }) => c.name_ === "QualitySelector")
      ) {
        this.controlBar.addChild("QualitySelector");
      }
    });
    return () => {
      if (player.current) {
        player.current.dispose();
      }
    };
  }, [options]);

  return (
    <video
      ref={videoNode}
      className={cn("video-js", className)}
      style={style}
    />
  );
};

export default VideoPlayer;
